import DashboardLayout from '@/components/Main/Dashboard/Layout/DashboardLayout.vue';

import Overview from '@/components/Main/Overview.vue';

// Family & Customer Dashboard
import UserProfile from '@/components/Main/Family/Profile.vue';
import LiveRideMap from '@/components/Main/Family/LiveRideMap.vue';
import FamilyRideOrdering from '@/components/Main/Family/RideOrdering.vue';
const BookRide = () => import('@/components/Main/Shared/BookRide/BookRide.vue');
import FamilyPayments from '@/components/Main/Family/PaymentMethods.vue';
import RideCredits from '@/components/Main/Family/RideCredits.vue';
import RideHistory from '@/components/Main/Family/RideHistory.vue';
import FamilyGroceryHistory from '@/components/Main/Family/GroceryHistory.vue';
import FamilyGroceryLists from '@/components/Main/Family/GroceryLists.vue';
import FamilyGourmetHistory from '@/components/Main/Family/GourmetHistory.vue';
import FamilyReceipts from '@/components/Main/Family/Receipts.vue';
import FamilyMembers from '@/components/Main/Family/FamilyMembers.vue';
import AddFamilyMember from '@/components/Main/Family/AddFamilyMember.vue';
import AboutGoGo from '@/components/Main/Family/KnowledgeBase/AboutGoGo.vue';
import MembershipPlan from '@/components/Main/Family/MembershipPlan.vue';
import ActiveHours from '@/components/Main/Family/ActiveHours.vue';
import HomeServicesRequests from '@/components/Main/Family/HomeServicesRequests.vue';
import FamilyCustomLocations from '@/components/Main/Family/CustomLocations.vue';
import ContactUs from '@/components/Main/Family/ContactUs.vue';
import HowToDocument from '@/components/Main/Family/KnowledgeBase/HowToDocument.vue';
import ReorderDelivery from '@/components/Main/Family/ReorderDelivery.vue';

// User Management Pages
import Login from '@/components/Main/Dashboard/Views/Login.vue';
import ResetPassword from '@/components/Main/Dashboard/Views/ResetPassword.vue';
import SetupPassword from '@/components/Main/Dashboard/Views/SetupPassword.vue';
import CompleteRegistration from '@/components/Main/User/CompleteRegistration.vue';
import DisplayCallerDateEvents from '@/components/Main/User/DisplayCallerDateEvents.vue';
import CustomerAddPaymentMethod from '@/components/Main/User/AddPaymentMethod.vue';

// Operator Dashboard
import Account from '@/components/Main/Operator/Account.vue';
import LiveCalls from '@/components/Main/Operator/LiveCalls.vue';
import AddOperator from '@/components/Main/Operator/Operator/AddOperator.vue';
import SMSBoard from '@/components/Main/Operator/SMSBoard.vue';
import LiveRide from '@/components/Main/Operator/LiveRide.vue';
import RideOrderingPage from '@/components/Main/Operator/RideOrderingPage.vue';
import LiveAlerts from '@/components/Main/Operator/LiveAlerts.vue';
import OperatorTasks from '@/components/Main/Operator/OperatorTasks.vue';
import CustomerSearch from '@/components/Main/Operator/CustomerSearch.vue';
import RideSearch from '@/components/Main/Operator/RideSearch.vue';
import EmailSearch from '@/components/Main/Operator/EmailSearch.vue';
import ReferralSearch from '@/components/Main/Operator/ReferralSearch.vue';
import SMSSearch from '@/components/Main/Operator/SMSSearch.vue';
import MailingSearch from '@/components/Main/Operator/MailingSearch.vue';
import CustomLocations from '@/components/Main/Operator/CustomLocations.vue';
import CallLogs from '@/components/Main/Operator/CallLogs.vue';
import BulkTranscribeCallLogs from '@/components/Main/Operator/BulkTranscribeCallLogs.vue';
import QaCalibrations from '@/components/Main/Operator/QaCalibrations/QaCalibrations.vue';
import CallSummary from '@/components/Main/Operator/CallSummary.vue';
import Receipts from '@/components/Main/Operator/Receipts.vue';
import Marketing from '@/components/Main/Operator/Marketing.vue';
import Blacklist from '@/components/Main/Operator/Blacklist.vue';
import NeedLove from '@/components/Main/Operator/NeedLove.vue';
import ServiceCheck from '@/components/Main/Operator/ServiceCheck.vue';
import ScheduledRides from '@/components/Main/Operator/ScheduledRides.vue';
import WillCallRides from '@/components/Main/Operator/WillCallRides.vue';
import Payments from '@/components/Main/Operator/Payments.vue';
import Checks from '@/components/Main/Operator/Checks.vue';
import OperatorRideCredits from '@/components/Main/Operator/RideCredits.vue';
import SendAnonymous from '@/components/Main/Operator/SendAnonymous.vue';
import Agent from '@/components/Main/Operator/Agent/Agent.vue';
import Management from '@/components/Main/Operator/Management.vue';
import UserInteractions from '@/components/Main/Operator/UserInteractions.vue';
import CustomerResetPassword from '@/components/Main/Operator/CustomerResetPassword.vue';
import OperatorFamilyMember from '@/components/Main/Operator/FamilyMembers.vue';
import Faq from '@/components/Main/Operator/Faq.vue';
import Operators from '@/components/Main/Operator/Operators.vue';
import LossPrevention from '@/components/Main/Operator/LossPrevention.vue';
import PingTest from '@/components/Main/Operator/PingTest.vue';
import Gourmet from '@/components/Main/Operator/Gourmet.vue';
import UserCallSmsEmailMail from '@/components/Main/Operator/UserCallSmsEmailMail.vue';
import PartnerCallSmsEmailMail from '@/components/Main/Partner/PartnerCallSmsEmailMail.vue';
import FraudCheck from '@/components/Main/Operator/FraudCheck.vue';
import RideMonitoring from '@/components/Main/Operator/RideMonitoring.vue';
import DisplayEmailExample from '@/components/Main/Operator/DisplayEmailExample.vue';
import DisplaySmsExample from '@/components/Main/Operator/DisplaySmsExample.vue';
import UserPlan from '@/components/Main/Operator/UserPlan.vue';
import RequestHomeServices from '@/components/Main/Operator/HomeServices/RequestHomeServices.vue';
import HomeServiceProviders from '@/components/Main/Operator/HomeServices/Providers.vue';
import CreateUpdateProvider from '@/components/Main/Operator/HomeServices/CreateUpdateProvider.vue';
import HomeServiceOrders from '@/components/Main/Operator/HomeServices/Orders.vue';
import UpdateHomeServiceOrder from '@/components/Main/Operator/HomeServices/UpdateOrder.vue';
import TeamLeads from '@/components/Main/Operator/TeamLeads.vue';
import MonthlyRegistrationRetention from '@/components/Main/Operator/MonthlyRegistrationRetention.vue';
import AnnualRegistrationRetention from '@/components/Main/Operator/AnnualRegistrationRetention.vue';
import ServiceMetrics from '@/components/Main/Operator/ServiceMetrics.vue';
import OperatorIndividualStatistics from '@/components/Main/Operator/OperatorIndividualStatistics.vue';
import OperationMetrics from '@/components/Main/Operator/OperationMetrics.vue';
import Refunds from '@/components/Main/Operator/Refunds.vue';
import Calls from '@/components/Main/Operator/Calls.vue';
import MembershipPricing from '@/components/Main/Operator/MembershipPricing.vue';
import DeliveryEstimate from '@/components/Main/Operator/DeliveryEstimate.vue';
import Membership from '@/components/Main/Operator/Membership.vue';
import Plans from '@/components/Main/Operator/Plans.vue';
import PaymentTiers from '@/components/Main/Operator/PaymentTiers.vue';
import ServiceSurveys from '@/components/Main/Operator/ServiceSurveys.vue';
import UserForms from '@/components/Main/Operator/UserForms.vue';
import OperatorPerformances from '@/components/Main/Operator/OperatorPerformances.vue';
import AbTest from '@/components/Main/Operator/AbTest.vue';
import AiTools from '@/components/Main/Operator/AiTools.vue';
import OperatorRidePerformances from '@/components/Main/Operator/OperatorRidePerformances.vue';
import DashboardCustomization from '@/components/Main/Operator/DashboardCustomization.vue';
import WelcomeTexts from '@/components/Main/Operator/WelcomeTexts.vue';
const TestResults = () => import('@/components/Main/Operator/TestResults.vue');

// Delivery
import DeliverySMS from '@/components/Main/Operator/DeliverySMS.vue';
import DeliverySearch from '@/components/Main/Operator/DeliverySearch.vue';
import DeliveryOrders from '@/components/Main/Operator/DeliveryOrders.vue';
import DeliveryReceipts from '@/components/Main/Operator/DeliveryReceipts.vue';
import ScheduledDelivery from '@/components/Main/Operator/ScheduledDelivery.vue';
import DeliveryTransactions from '@/components/Main/Operator/DeliveryTransactions.vue';
import DeliveryManualOrder from '@/components/Main/Operator/DeliveryManualOrder.vue';
import DeliveryNeedLove from '@/components/Main/Operator/DeliveryNeedLove.vue';
import ServiceAccounts from '@/components/Main/Operator/ServiceAccounts.vue';
import ServiceAccountForm from '@/components/Main/Operator/ServiceAccounts/ServiceAccountForm.vue';
import GourmetRegistration from '@/components/Main/Operator/GourmetRegistration.vue';
import GourmetResumeRegistration from '@/components/Main/Operator/GourmetResumeRegistration.vue';

// Partners
import PartnerRideOrdering from '@/components/Main/Partner/RideOrdering.vue';
import PartnerCallerRegistrationPage from '@/components/Main/Partner/Registration.vue';
import PartnerCallerPayment from '@/components/Main/Partner/PaymentMethods.vue';
import PartnerRideCredits from '@/components/Main/Partner/RideCredits.vue';
import MarketingMaterials from '@/components/Main/Partner/MarketingMaterials.vue';
import PartnerRideHistory from '@/components/Main/Partner/PartnerRideHistory.vue';
import PartnerCallerRegistrationCSVPage from '@/components/Main/Partner/RegistrationByCsv.vue';
import PartnerCallStats from '@/components/Main/Partner/CallStats.vue';

import Partners from '@/components/Main/Operator/Partners.vue';
import PartnerRegistrationPage from '@/components/Main/Operator/Partners/PartnerRegistration/Registration.vue';
import PartnerAddMemberManually from '@/components/Main/Partner/AddMemberManually.vue';

// Grocery
import LiveGrocery from '@/components/Main/Operator/LiveGrocery.vue';
import DeliveryLiveOrders from '@/components/Main/Operator/DeliveryLiveOrders.vue';
import DeliveryOrderHistory from '@/components/Main/Operator/DeliveryOrderHistory.vue';
import Grocery from '@/components/Main/Operator/Grocery.vue';
import InstacartAccountForm from '@/components/Main/Operator/Grocery/InstacartAccountForm.vue';
import ScheduledGrocery from '@/components/Main/Operator/ScheduledGrocery.vue';
import ScheduledGroceryForm from '@/components/Main/Operator/Grocery/ScheduledGrocery/ScheduledGroceryForm.vue';
import SavedGrocery from '@/components/Main/Operator/SavedGrocery.vue';
import CreateSavedGrocery from '@/components/Main/Operator/CreateSavedGrocery.vue';
import GroceryLists from '@/components/Main/Operator/GroceryLists.vue';

import UpdateRideDestination from '@/components/Main/Dashboard/Views/UpdateRideDestination.vue';

// Affiliate
import Affiliate from '@/components/Main/Operator/Affiliate.vue';
import CreateUpdateAffiliate from '@/components/Main/Operator/Affiliate/CreateUpdateAffiliate.vue';
import AffiliateCustomers from '@/components/Main/Affiliate/Customers.vue';

// NeedLove
import UpdateNeedLoveFormPage from '@/components/Main/Operator/NeedLove/UpdateNeedLoveForm.vue';

import type { RouteRecordRaw } from 'vue-router';
import GroceryRegistration from '@/components/Main/Operator/Grocery/Registration/Registration.vue';
import TwoFactorEnrollment from '@/components/Main/Security/TwoFactorEnrollment.vue';
import DisableTwoFactor from '@/components/Main/Security/DisableTwoFactor.vue';
import ReAuthenticate from '@/components/Main/Security/ReAuthenticate.vue';

import { deliveryTabRoles } from '@/constants/deliveryOrder';
import { qaCalibrationRoles } from '@/constants/qaCalibration';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/operator/overview',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/operator',
        component: DashboardLayout,
        redirect: '/operator/overview',
        meta: {
          requiresAuth: true,
          roles: [
            'admin',
            'director',
            'supervisor',
            'supervisorTeamLead',
            'operator',
            'teamLead',
            'rideTeamLead',
            'gourmet-supervisor',
            'gourmet-operator',
            'lossPrevention',
            'qualityAssurance',
            'grocery-operator',
            'grocery-manager',
            'partnership-operator',
            'lossPreventionGourmet',
            'lossPreventionGrocery',
            'virtualAssistanceGrocery',
            'research-operator',
            'onboarding-team-lead',
            'delivery-operator',
            'affiliate-manager',
            'partnership-caller-operator',
            'bookings-operator',
            'doortodoor-operator',
            'homeServices-operator',
            'gogocare-operator',
            'cozy-operator',
            'research-admin',
            'pharmacy-registrations-operator',
            'pharmacy-operator',
            'gogo-welcome-operator',
            'partnership-registrations-operator',
            'ride-registrations-operator',
            'gourmet-registrations-operator',
            'grocery-registrations-operator',
            'delivery-registrations-operator',
            'gogocare-registrations-operator',
            'research-registrations-operator',
            'partnership-caller-registrations-operator',
            'homeServices-registrations-operator',
            'facebookLeads-registrations-operator',
            'overseas-operator',
          ],
        },
        children: [
          {
            path: 'overview',
            name: 'Overview',
            component: Overview,
            meta: {
              customPageName: 'Dashboard Overview',
            },
          },
          {
            path: 'dashboard-customization',
            name: 'DashboardCustomization',
            component: DashboardCustomization,
            meta: {
              customPageName: 'Dashboard customization',
            },
          },
          {
            path: 'account',
            name: 'Account',
            component: Account,
          },
          {
            path: 'live-calls',
            name: 'LiveCalls',
            component: LiveCalls,
          },
          {
            path: 'sms-board',
            name: 'SMS',
            component: SMSBoard,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'lossPrevention',
                'lossPreventionGourmet',
                'lossPreventionGrocery',
                'research-operator',
                'homeServices-operator',
                'gogo-welcome-operator',
                'facebookLeads-registrations-operator',
              ],
            },
          },
          {
            path: 'live-ride',
            name: 'LiveRide',
            component: LiveRide,
          },
          {
            path: 'ride-ordering',
            name: 'RideOrdering',
            component: RideOrderingPage,
          },
          {
            path: 'live-alerts',
            name: 'LiveAlerts',
            component: LiveAlerts,
            meta: {
              roles: ['admin', 'director', 'teamLead', 'lossPrevention'],
            },
          },
          {
            path: 'operator-tasks',
            name: 'OperatorTasks',
            component: OperatorTasks,
            meta: {
              roles: ['admin', 'director', 'teamLead', 'supervisor', 'onboarding-team-lead', 'rideTeamLead', 'lossPrevention'],
            },
          },
          {
            path: 'ride-monitoring',
            name: 'RideMonitoring',
            component: RideMonitoring,
          },
          {
            path: 'user-search',
            name: 'CustomerSearch',
            component: CustomerSearch,
          },
          {
            path: 'email-search',
            name: 'EmailSearch',
            component: EmailSearch,
          },
          {
            path: 'sms-search',
            name: 'SMSSearch',
            component: SMSSearch,
          },
          {
            path: 'referral-search',
            name: 'ReferralSearch',
            component: ReferralSearch,
          },
          {
            path: 'ride-history',
            name: 'RideHistory',
            component: RideSearch,
          },
          {
            path: 'mailings-search',
            name: 'MailingsSearch',
            component: MailingSearch,
          },
          {
            path: 'custom-locations',
            name: 'CustomLocations',
            component: CustomLocations,
          },
          {
            path: 'communication-preferences',
            name: 'UserCommunicationPreferences',
            component: UserCallSmsEmailMail,
          },
          {
            path: 'call-logs',
            name: 'CallLogs',
            component: CallLogs,
          },
          {
            path: 'qa-calibrations',
            name: 'QaCalibrations',
            component: QaCalibrations,
            meta: {
              roles: qaCalibrationRoles,
            },
          },
          {
            path: 'bulk-transcribe-call-logs',
            name: 'BulkTranscribeCallLogs',
            component: BulkTranscribeCallLogs,
            meta: {
              roles: ['admin', 'director'],
            },
          },
          {
            path: 'call-summary',
            name: 'CallSummary',
            component: CallSummary,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'teamLead',
                'lossPrevention',
                'qualityAssurance',
                'rideTeamLead',
                'gourmet-supervisor',
                'grocery-manager',
                'qualityAssurance',
              ],
            },
          },
          {
            path: 'service-check',
            name: 'ServiceCheck',
            component: ServiceCheck,
          },
          {
            path: 'scheduled-rides',
            name: 'ScheduledRides',
            component: ScheduledRides,
          },
          {
            path: 'willcall-rides',
            name: 'WillCallRides',
            component: WillCallRides,
          },
          {
            path: 'receipts',
            name: 'Receipts',
            component: Receipts,
          },
          {
            path: 'marketing',
            name: 'Marketing',
            component: Marketing,
          },
          {
            path: 'ping-test',
            name: 'PingTest',
            component: PingTest,
          },
          {
            path: 'membership-pricing',
            name: 'MembershipPricing',
            component: MembershipPricing,
          },
          {
            path: 'blacklist',
            name: 'Blacklist',
            component: Blacklist,
          },
          {
            path: 'payments',
            name: 'Payments',
            component: Payments,
          },
          {
            path: 'checks',
            name: 'Checks',
            component: Checks,
            meta: {
              roles: ['research-admin'],
            },
          },
          {
            path: 'ride-credits',
            name: 'GoGoCredits',
            component: OperatorRideCredits,
          },
          {
            path: 'need-love',
            name: 'NeedLove',
            component: NeedLove,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'operator',
                'teamLead',
                'lossPrevention',
                'qualityAssurance',
                'partnership-operator',
                'gourmet-operator',
                'grocery-operator',
                'rideTeamLead',
                'grocery-manager',
                'gourmet-supervisor',
              ],
            },
          },
          {
            path: 'management',
            name: 'Management',
            component: Management,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'teamLead',
                'lossPrevention',
                'partnership-operator',
                'rideTeamLead',
                'grocery-manager',
                'gourmet-supervisor',
              ],
            },
          },
          {
            path: 'test-results',
            name: 'TestResults',
            component: TestResults,
            meta: {
              roles: ['admin', 'director', 'supervisor', 'teamLead', 'onboardingTeamLead'],
            },
          },
          {
            path: 'team-leads',
            name: 'TeamLeads',
            component: TeamLeads,
            meta: {
              roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead'],
            },
          },
          {
            path: 'membership',
            name: 'Membership',
            component: Membership,
          },
          {
            path: 'plans',
            name: 'Plans',
            component: Plans,
            meta: {
              roles: ['admin', 'director'],
            },
          },
          {
            path: 'payment-tiers',
            name: 'PaymentTiers',
            component: PaymentTiers,
            meta: {
              roles: ['admin', 'director'],
            },
          },
          {
            path: 'user-interactions',
            name: 'UserInteractions',
            component: UserInteractions,
          },
          {
            path: 'partners',
            name: 'Partners',
            component: Partners,
          },
          {
            path: 'partner-registration',
            name: 'CreatePartnerInfo',
            component: PartnerRegistrationPage,
            meta: {
              roles: ['admin', 'partnership-operator'],
            },
          },
          {
            path: 'partner-update/:codeName',
            name: 'UpdatePartnerInfo',
            component: PartnerRegistrationPage,
            meta: {
              roles: ['admin', 'partnership-operator'],
            },
          },
          {
            path: 'subsidy-create/:partnerCodeName',
            name: 'CreatePartnerSubsidyLocation',
            component: () => import('@/components/Main/Operator/Partners/Subsidy/UpdatePartnerSubsidyLocation.vue'),
            meta: {
              roles: ['admin', 'partnership-operator'],
            },
          },
          {
            path: 'subsidy-update/:partnerCodeName',
            name: 'UpdatePartnerSubsidy',
            component: () => import('@/components/Main/Operator/Partners/Subsidy/UpdatePartnerSubsidy.vue'),
            meta: {
              roles: ['admin', 'partnership-operator'],
            },
          },
          {
            path: 'subsidy-update/:partnerCodeName/:id',
            name: 'UpdatePartnerSubsidyLocation',
            component: () => import('@/components/Main/Operator/Partners/Subsidy/UpdatePartnerSubsidyLocation.vue'),
            meta: {
              roles: ['admin', 'partnership-operator'],
            },
          },
          {
            path: 'need-love/update/:id',
            name: 'UpdateNeedLoveForm',
            component: UpdateNeedLoveFormPage,
            meta: {
              roles: [
                'admin',
                'operator',
                'teamLead',
                'lossPrevention',
                'supervisor',
                'rideTeamLead',
                'grocery-manager',
                'gourmet-supervisor',
              ],
            },
          },
          {
            path: 'submit-kudos-call',
            name: 'SubmitKudosCall',
            component: SendAnonymous,
          },
          {
            path: 'agent/agent',
            name: 'AIAgent',
            component: Agent,
            meta: {
              roles: ['admin', 'director', 'teamLead', 'qualityAssurance', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
            },
          },
          {
            path: 'faq',
            name: 'FAQ',
            component: Faq,
          },
          {
            path: 'registration',
            name: 'RegistrationPage',
            component: () => import('@/components/Main/Operator/RideRegistration/Registration.vue'),
          },
          {
            path: 'resume-registration',
            name: 'ResumeRegistrationPage',
            component: () => import('@/components/Main/Operator/RideRegistration/ResumeRegistration.vue'),
          },
          {
            path: 'customer-reset-password',
            name: 'CustomerResetPassword',
            component: CustomerResetPassword,
          },
          {
            path: 'family-member',
            name: 'FamilyMember',
            component: OperatorFamilyMember,
          },
          {
            path: 'operators',
            name: 'ManageOperators',
            component: Operators,
            meta: {
              roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
            },
          },
          {
            path: 'loss-prevention',
            name: 'LossPreventionOverview',
            component: LossPrevention,
            meta: {
              roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
            },
          },
          {
            path: 'add-operator',
            name: 'AddOperator',
            component: AddOperator,
            meta: {
              roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
            },
          },
          {
            path: 'fraud-check',
            name: 'FraudCheck',
            component: FraudCheck,
          },
          {
            path: 'gourmet',
            name: 'Gourmet',
            component: Gourmet,
          },
          {
            path: 'delivery-sms',
            name: 'GourmetSMS',
            component: DeliverySMS,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'gourmet-supervisor',
                'gourmet-operator',
                'lossPreventionGourmet',
                'grocery-operator',
                'grocery-manager',
              ],
            },
          },
          {
            path: 'delivery-search/:copyId?',
            name: 'DeliverySearch',
            component: DeliverySearch,
          },
          {
            path: 'delivery-receipt',
            name: 'DeliveryReceipt',
            component: DeliveryReceipts,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'gourmet-supervisor',
                'gourmet-operator',
                'lossPreventionGourmet',
                'grocery-operator',
                'rideTeamLead',
              ],
            },
          },
          {
            path: 'create-service-account',
            name: 'CreateServiceAccount',
            component: ServiceAccountForm,
            meta: {
              roles: ['admin', 'director', 'gourmet-supervisor', 'lossPreventionGourmet'],
            },
          },
          {
            path: 'update-service-account',
            name: 'UpdateServiceAccount',
            component: ServiceAccountForm,
            meta: {
              roles: ['admin', 'director', 'gourmet-supervisor', 'lossPreventionGourmet'],
            },
          },
          {
            path: 'service-accounts',
            name: 'ServiceAccounts',
            component: ServiceAccounts,
            meta: {
              roles: ['admin', 'director', 'gourmet-supervisor', 'lossPreventionGourmet'],
            },
          },
          {
            path: 'scheduled-delivery',
            name: 'ScheduledDelivery',
            component: ScheduledDelivery,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'gourmet-supervisor',
                'gourmet-operator',
                'lossPreventionGourmet',
                'grocery-operator',
              ],
            },
          },
          {
            path: 'delivery-manual-order',
            name: 'ManualOrder',
            component: DeliveryManualOrder,
            meta: {
              roles: ['admin', 'director', 'gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator'],
            },
          },
          {
            path: 'gourmet-estimator',
            name: 'GourmetEstimator',
            component: DeliveryEstimate,
          },
          {
            path: 'delivery-transactions',
            name: 'DeliveryTransactions',
            component: DeliveryTransactions,
            meta: {
              roles: ['gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator'],
            },
          },
          {
            path: 'delivery-need-love',
            name: 'DeliveryNeedLove',
            component: DeliveryNeedLove,
            meta: {
              roles: ['admin', 'gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator', 'grocery-manager'],
            },
          },
          {
            path: 'gourmet-registration',
            name: 'GourmetRegistration',
            component: GourmetRegistration,
            meta: {
              roles: ['admin', 'gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator'],
            },
          },
          {
            path: 'gourmet-resume-registration',
            name: 'GourmetResumeRegistration',
            component: GourmetResumeRegistration,
            meta: {
              roles: ['admin', 'gourmet-supervisor', 'gourmet-operator', 'lossPreventionGourmet', 'grocery-operator'],
            },
          },
          {
            path: 'live-grocery',
            name: 'LiveGrocery',
            component: LiveGrocery,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'grocery-operator',
                'grocery-manager',
                'lossPreventionGrocery',
                'virtualAssistanceGrocery',
                'gourmet-operator',
              ],
            },
          },
          {
            path: 'live-deliveries',
            name: 'LiveDeliveries',
            component: DeliveryLiveOrders,
            meta: {
              roles: deliveryTabRoles,
            },
          },
          {
            path: 'delivery-order-history',
            name: 'DeliveryOrderHistory',
            component: DeliveryOrderHistory,
            meta: {
              roles: deliveryTabRoles,
            },
          },
          {
            path: 'grocery',
            name: 'Grocery',
            component: Grocery,
          },
          {
            path: 'grocery/registration',
            name: 'GroceryRegistration',
            component: GroceryRegistration,
          },
          {
            path: 'saved-grocery',
            name: 'SavedGrocery',
            component: SavedGrocery,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'grocery-operator',
                'grocery-manager',
                'lossPreventionGrocery',
                'virtualAssistanceGrocery',
                'gourmet-operator',
              ],
            },
          },
          {
            path: 'create-saved-grocery',
            name: 'CreateSavedGrocery',
            component: CreateSavedGrocery,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'grocery-operator',
                'grocery-manager',
                'lossPreventionGrocery',
                'virtualAssistanceGrocery',
                'gourmet-operator',
              ],
            },
          },
          {
            path: 'grocery-lists',
            name: 'GroceryLists',
            component: GroceryLists,
            meta: {
              roles: ['admin', 'director', 'supervisor', 'grocery-operator', 'grocery-manager', 'gourmet-operator'],
            },
          },
          {
            path: 'scheduled-grocery',
            name: 'ScheduledGrocery',
            component: ScheduledGrocery,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'grocery-operator',
                'grocery-manager',
                'lossPreventionGrocery',
                'virtualAssistanceGrocery',
                'gourmet-operator',
              ],
            },
          },
          {
            path: 'scheduled-grocery-form',
            name: 'ScheduledGroceryForm',
            component: ScheduledGroceryForm,
            meta: {
              roles: [
                'admin',
                'director',
                'supervisor',
                'grocery-operator',
                'grocery-manager',
                'lossPreventionGrocery',
                'virtualAssistanceGrocery',
                'gourmet-operator',
              ],
            },
          },
          {
            path: 'create-instacart-account',
            name: 'CreateInstacartAccount',
            component: InstacartAccountForm,
            meta: {
              roles: ['admin', 'supervisor'],
            },
          },
          {
            path: 'update-instacart-account',
            name: 'UpdateInstacartAccount',
            component: InstacartAccountForm,
            meta: {
              roles: ['admin', 'supervisor'],
            },
          },
          {
            path: 'display-email-example',
            name: 'DisplayEmailExample',
            component: DisplayEmailExample,
          },
          {
            path: 'display-sms-example',
            name: 'DisplaySMSExample',
            component: DisplaySmsExample,
          },
          {
            path: 'user-plan',
            name: 'UserPlan',
            component: UserPlan,
          },
          {
            path: 'home-services',
            redirect: '/operator/home-services/request',
            children: [
              {
                path: 'request',
                name: 'NewServiceRequest',
                component: RequestHomeServices,
              },
              {
                path: 'providers',
                name: 'HomeServiceProviders',
                component: HomeServiceProviders,
              },
              {
                path: 'provider/:id?',
                name: 'CreateUpdateProvider',
                component: CreateUpdateProvider,
              },
              {
                path: 'orders',
                name: 'HomeServiceOrders',
                component: HomeServiceOrders,
              },
              {
                path: 'order/:id?',
                name: 'UpdateHomeServiceOrder',
                component: UpdateHomeServiceOrder,
              },
            ],
          },
          {
            path: 'facebook',
            redirect: '/operator/facebook/registration',
            children: [
              {
                path: 'registration',
                name: 'FacebookRegistration',
                component: () => import('@/components/Main/Operator/LeadRegistration/Registration.vue'),
              },
            ],
          },
          {
            path: 'monthly-registration-retention',
            name: 'MonthlyRegistrationRetention',
            meta: {
              roles: ['admin', 'director', 'supervisor'],
            },
            component: MonthlyRegistrationRetention,
          },
          {
            path: 'annual-registration-retention',
            name: 'AnnualRegistrationRetention',
            meta: {
              roles: ['admin', 'director', 'supervisor'],
            },
            component: AnnualRegistrationRetention,
          },
          {
            path: 'service-metrics',
            name: 'ServiceMetrics',
            component: ServiceMetrics,
          },
          {
            path: 'individual-statistics',
            name: 'IndividualStatistics',
            component: OperatorIndividualStatistics,
          },
          {
            path: 'operation-metrics',
            name: 'OperationMetrics',
            component: OperationMetrics,
          },
          {
            path: 'ab-tests',
            name: 'A/BTests',
            component: AbTest,
          },
          {
            path: 'ai-tools',
            name: 'AI Tools',
            component: AiTools,
          },
          {
            path: 'affiliate',
            name: 'Affiliate',
            component: Affiliate,
            meta: {
              roles: ['admin', 'affiliate-manager'],
            },
          },
          {
            path: 'affiliate-create',
            name: 'CreateAffiliate',
            component: CreateUpdateAffiliate,
            meta: {
              roles: ['admin', 'affiliate-manager'],
            },
          },
          {
            path: 'affiliate-update/:codeName',
            name: 'UpdateAffiliate',
            component: CreateUpdateAffiliate,
            meta: {
              roles: ['admin', 'affiliate-manager'],
            },
          },
          {
            path: 'calls',
            name: 'Calls',
            component: Calls,
            meta: {
              roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
            },
          },
          {
            path: 'refunds',
            name: 'Refunds',
            component: Refunds,
            meta: {
              roles: ['admin', 'director', 'supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'gourmet-supervisor'],
            },
          },
          {
            path: 'service-surveys',
            name: 'ServiceSurveys',
            component: ServiceSurveys,
          },
          {
            path: 'user-forms',
            name: 'UserForms',
            component: UserForms,
          },
          {
            path: 'registration-performances',
            name: 'OperatorRegistrationPerformances',
            component: OperatorPerformances,
          },
          {
            path: 'ride-performances',
            name: 'OperatorRidePerformances',
            component: OperatorRidePerformances,
          },
          {
            path: 'forms',
            name: 'Forms',
            component: UserForms,
          },
          {
            path: '2fa',
            name: 'OperatorTwo-FactorAuthentication',
            meta: {
              customPageName: 'Two-Factor Authentication',
            },
            component: TwoFactorEnrollment,
          },
          {
            path: '2fa/disable',
            name: 'OperatorDisableTwo-FactorAuthentication',
            meta: {
              customPageName: 'Disable Two-Factor Authentication',
            },
            component: DisableTwoFactor,
          },
          {
            path: 're-authenticate',
            name: 'OperatorRe-Authenticate',
            meta: {
              customPageName: 'Re-Authenticate',
            },
            component: ReAuthenticate,
          },
          {
            path: 'welcome-texts',
            name: 'WelcomeTexts',
            component: WelcomeTexts,
          },
        ],
      },
      {
        path: '/family',
        component: DashboardLayout,
        redirect: '/family/ride-ordering',
        meta: {
          requiresAuth: true,
          roles: [
            'admin',
            'director',
            'supervisor',
            'supervisorTeamLead',
            'operator',
            'teamLead',
            'rideTeamLead',
            'gourmet-supervisor',
            'gourmet-operator',
            'lossPrevention',
            'qualityAssurance',
            'grocery-operator',
            'grocery-manager',
            'partnership-operator',
            'lossPreventionGourmet',
            'lossPreventionGrocery',
            'virtualAssistanceGrocery',
            'research-operator',
            'onboarding-team-lead',
            'delivery-operator',
            'affiliate-manager',
            'partnership-caller-operator',
            'bookings-operator',
            'doortodoor-operator',
            'homeServices-operator',
            'gogocare-operator',
            'cozy-operator',
            'research-admin',
            'pharmacy-registrations-operator',
            'pharmacy-operator',
            'gogo-welcome-operator',
            'partnership-registrations-operator',
            'ride-registrations-operator',
            'gourmet-registrations-operator',
            'grocery-registrations-operator',
            'delivery-registrations-operator',
            'gogocare-registrations-operator',
            'research-registrations-operator',
            'partnership-caller-registrations-operator',
            'homeServices-registrations-operator',
            'facebookLeads-registrations-operator',
            'overseas-operator',
            'family',
            'customer',
          ],
        },
        children: [
          {
            path: 'profile',
            name: 'Profile',
            component: UserProfile,
          },
          {
            path: 'ride-ordering',
            name: 'FamilyRideOrdering',
            meta: {
              customPageName: 'Ride Ordering',
            },
            component: FamilyRideOrdering,
          },
          {
            path: 'book-ride',
            name: 'FamilyBookRide',
            meta: {
              customPageName: 'Book a Ride',
            },
            component: BookRide,
          },
          {
            path: 'live-ride-map',
            name: 'LiveRideMap',
            component: LiveRideMap,
          },
          {
            path: 'payment-methods',
            name: 'PaymentMethods',
            component: FamilyPayments,
          },
          {
            path: 'ride-credits',
            name: 'FamilyGoGoCredits',
            meta: {
              customPageName: 'GoGo Credits',
            },
            component: RideCredits,
          },
          {
            path: 'ride-history',
            name: 'FamilyRideHistory',
            meta: {
              customPageName: 'Ride History',
            },
            component: RideHistory,
          },
          {
            path: 'scheduled-rides',
            name: 'FamilyScheduledRides',
            meta: {
              customPageName: 'Scheduled Rides',
            },
            component: ScheduledRides,
          },
          {
            path: 'grocery-history',
            name: 'FamilyGroceryHistory',
            meta: {
              customPageName: 'Grocery History',
            },
            component: FamilyGroceryHistory,
          },
          {
            path: 'grocery-lists',
            name: 'FamilyGroceryLists',
            meta: {
              customPageName: 'Grocery Lists',
            },
            component: FamilyGroceryLists,
          },
          {
            path: 'gourmet-history',
            name: 'FamilyGourmetHistory',
            meta: {
              customPageName: 'Gourmet History',
            },
            component: FamilyGourmetHistory,
          },
          {
            path: 'receipts',
            name: 'FamilyReceipts',
            meta: {
              customPageName: 'Receipts',
            },
            component: FamilyReceipts,
          },
          {
            path: 'family-members',
            name: 'FamilyMembers',
            meta: {
              customPageName: 'Family Contacts',
            },
            component: FamilyMembers,
          },
          {
            path: 'add-family-member',
            name: 'AddFamilyMember',
            component: AddFamilyMember,
          },
          {
            path: 'about-gogo',
            name: 'AboutGoGo',
            component: AboutGoGo,
          },
          {
            path: 'membership-plan',
            name: 'MembershipPlan',
            component: MembershipPlan,
          },
          {
            path: 'active-hours',
            name: 'ActiveHours',
            component: ActiveHours,
          },
          {
            path: 'home-services-requests',
            name: 'HomeServicesRequests',
            component: HomeServicesRequests,
          },
          {
            path: 'custom-locations',
            name: 'FamilyCustomLocations',
            component: FamilyCustomLocations,
          },
          {
            path: 'contact-us',
            name: 'ContactUs',
            component: ContactUs,
          },
          {
            path: 'how-to-document',
            name: 'HowToDocument',
            component: HowToDocument,
          },
          {
            path: 'reorder-delivery/:copyId?',
            name: 'ReorderDelivery',
            component: ReorderDelivery,
            meta: {
              customPageName: 'Reorder Meal',
            },
          },
          {
            path: '2fa',
            name: 'FamilyTwo-FactorAuthentication',
            meta: {
              customPageName: 'Two-Factor Authentication',
            },
            component: TwoFactorEnrollment,
          },
          {
            path: '2fa/disable',
            name: 'FamilyDisableTwo-FactorAuthentication',
            meta: {
              customPageName: 'Disable Two-Factor Authentication',
            },
            component: DisableTwoFactor,
          },
          {
            path: 're-authenticate',
            name: 'FamilyRe-Authenticate',
            meta: {
              customPageName: 'Re-Authenticate',
            },
            component: ReAuthenticate,
          },
        ],
      },
      {
        path: '/partner',
        component: DashboardLayout,
        redirect: '/partner/overview',
        meta: {
          requiresAuth: true,
          roles: ['partner'],
        },
        children: [
          {
            path: 'overview',
            name: 'PartnerOverview',
            meta: {
              customPageName: 'Dashboard Overview',
            },
            component: Overview,
          },
          {
            path: 'user-search',
            name: 'PartnerCustomerSearch',
            meta: {
              customPageName: 'Customer Search',
            },
            component: CustomerSearch,
          },
          {
            path: 'ride-history',
            name: 'PartnerRideHistory',
            meta: {
              customPageName: 'Ride History',
            },
            component: PartnerRideHistory,
          },
          {
            path: 'ride-ordering',
            name: 'PartnerRideOrdering',
            meta: {
              customPageName: 'Ride Ordering',
            },
            component: PartnerRideOrdering,
          },
          {
            path: 'book-ride',
            name: 'PartnerBookRide',
            meta: {
              customPageName: 'Book a Ride',
            },
            component: BookRide,
          },
          {
            path: 'scheduled-rides',
            name: 'PartnerScheduledRides',
            meta: {
              customPageName: 'Scheduled Rides',
            },
            component: ScheduledRides,
          },
          {
            path: 'willcall-rides',
            name: 'PartnerWillCallRides',
            meta: {
              customPageName: 'Will Call Rides',
            },
            component: WillCallRides,
          },
          {
            path: 'call-logs',
            name: 'PartnerCallLogs',
            meta: {
              customPageName: 'Call Logs',
            },
            component: CallLogs,
          },
          {
            path: 'delivery-search/:copyId?',
            name: 'PartnerDeliverySearch',
            component: DeliverySearch,
            meta: {
              roles: ['Immanuel'],
              customPageName: 'Delivery Search',
            },
          },
          {
            path: 'delivery-orders/:id?',
            name: 'PartnerDeliveryOrders',
            component: DeliveryOrders,
            meta: {
              roles: ['Immanuel'],
              customPageName: 'Delivery Orders',
            },
          },
          {
            path: 'custom-locations',
            name: 'PartnerCustomLocations',
            meta: {
              customPageName: 'Custom Locations',
            },
            component: CustomLocations,
          },
          {
            path: 'payment-methods',
            name: 'PartnerPayments',
            meta: {
              customPageName: 'Payments',
            },
            component: PartnerCallerPayment,
          },
          {
            path: 'ride-credits',
            name: 'PartnerGoGoCredits',
            meta: {
              customPageName: 'GoGo Credits',
            },
            component: PartnerRideCredits,
          },
          {
            path: 'service-check',
            name: 'PartnerServiceCheck',
            meta: {
              customPageName: 'Service Check',
            },
            component: ServiceCheck,
          },
          {
            path: 'receipts',
            name: 'PartnerReceipts',
            meta: {
              customPageName: 'Receipts',
            },
            component: Receipts,
          },
          {
            path: 'registration',
            name: 'PartnerRegistration',
            component: PartnerCallerRegistrationPage,
          },
          {
            path: 'registration-csv',
            name: 'PartnerRegistrationCSV',
            meta: {
              customPageName: 'Registration by CSV',
            },
            component: PartnerCallerRegistrationCSVPage,
          },
          {
            path: 'add-member-manually',
            name: 'PartnerAddMemberManually',
            meta: {
              customPageName: 'Add Member Manually',
            },
            component: PartnerAddMemberManually,
          },
          {
            path: 'marketing-marterials',
            name: 'PartnerMarketingMaterials',
            meta: {
              customPageName: 'Marketing Materials',
            },
            component: MarketingMaterials,
          },
          {
            path: 'partner-communication-preferences',
            name: 'CommunicationPreferences',
            component: PartnerCallSmsEmailMail,
          },
          {
            path: '2fa',
            name: 'PartnerTwo-FactorAuthentication',
            meta: {
              customPageName: 'Two-Factor Authentication',
            },
            component: TwoFactorEnrollment,
          },
          {
            path: '2fa/disable',
            name: 'PartnerDisableTwo-FactorAuthentication',
            meta: {
              customPageName: 'Disable Two-Factor Authentication',
            },
            component: DisableTwoFactor,
          },
          {
            path: 're-authenticate',
            name: 'PartnerRe-Authenticate',
            meta: {
              customPageName: 'Re-Authenticate',
            },
            component: ReAuthenticate,
          },
          {
            path: 'call-stats',
            name: 'CallStats',
            component: PartnerCallStats,
          },
        ],
      },
      {
        path: '/affiliate',
        component: DashboardLayout,
        redirect: '/affiliate/overview',
        meta: {
          requiresAuth: true,
          roles: ['affiliate'],
        },
        children: [
          {
            path: 'overview',
            name: 'AffiliateOverview',
            meta: {
              customPageName: 'Dashboard Overview',
            },
            component: AffiliateCustomers,
          },
          {
            path: '2fa',
            name: 'AffiliateTwo-FactorAuthentication',
            meta: {
              customPageName: 'Two-Factor Authentication',
            },
            component: TwoFactorEnrollment,
          },
          {
            path: '2fa/disable',
            name: 'AffiliateDisableTwo-FactorAuthentication',
            meta: {
              customPageName: 'Disable Two-Factor Authentication',
            },
            component: DisableTwoFactor,
          },
          {
            path: 're-authenticate',
            name: 'AffiliateRe-Authenticate',
            meta: {
              customPageName: 'Re-Authenticate',
            },
            component: ReAuthenticate,
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/otp-login',
    name: 'OTPLogin',
    component: () => import('@/components/Main/Dashboard/Views/OTPLogin.vue'),
  },
  {
    path: '/reset',
    name: 'ResetPassword',
    component: ResetPassword,
  },
  {
    path: '/reset/:token',
    name: 'ResetPasswordWithToken',
    component: ResetPassword,
  },
  {
    path: '/setup-password/:token',
    name: 'SetupPassword',
    component: SetupPassword,
  },
  {
    path: '/update-ride-destination/:requestId',
    name: 'UpdateRideDestination',
    component: UpdateRideDestination,
  },
  {
    path: '/complete-registration/:encodedMetadata',
    name: 'CompleteRegistration',
    component: CompleteRegistration,
  },
  {
    path: '/complete-registration-gourmet/:encodedMetadata',
    name: 'CompleteRegistrationGourmet',
    component: CompleteRegistration,
    meta: { isGourmetRegistration: true },
  },
  {
    path: '/caller-date-events',
    name: 'CallerDateEvents',
    component: DisplayCallerDateEvents,
  },
  {
    path: '/add-payment-method/:token',
    name: 'CustomerAddPaymentMethod',
    component: CustomerAddPaymentMethod,
  },
  {
    path: '/confirm-card/:token?',
    name: 'ConfirmCard',
    component: () => import('@/components/Main/User/ConfirmCard.vue'),
  },
  {
    path: '/cancel/:code',
    name: 'CancelRetention',
    component: () => import('@/components/Main/User/CancelRetention.vue'),
  },
  // {
  //   path: '/register',
  // },
  // {
  //   path: '/registration',
  // },
  // {
  //   path: '/signup',
  //   name: 'Signup Page',
  // },
  // {
  //   path: '/join',
  //   name: 'Join Page',
  // },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  { string } name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
